import _ from 'lodash';
import * as adapi from '~/utils/adapi';
import FormInput from '~/components/form-input/FormInput.vue';

export default {
  props: {
    platform: {
      type: String,
      required: true,
    },
  },
  components: {
    FormInput,
  },
  data() {
    return {
      loading: false,
      email: null,
      newPassword: null,
      newPasswordConfirm: null,
    };
  },
  computed: {
    activationCode() {
      return _.get(this.$route, 'params.code', null);
    },
    nextRoute() {
      return _.get(this.$route, 'query.next', null);
    },
    firstLogin() {
      return _.get(this.$route, 'query.first', null);
    },
  },
  methods: {
    onSendPasswordResetEmail() {
      if (this.email) {
        this.loading = true;
        adapi.post('users/restore-password', { email: this.email, platform: this.platform })
          .then(() => {
            this.loading = false;
            this.email = null;
            this.$toast.info({ message: this.$t('pos.login.recovery-code-sent') });
          })
          .catch(error => {
            this.loading = false;
            this.$toast.error({ message: error.toString() });
          });
      } else {
        this.$toast.error({ message: this.$t('pos.login.please-enter-your-email') });
      }
    },
    onChangePassword() {
      if (this.newPassword !== this.newPasswordConfirm) {
        this.$toast.error({ message: this.$t('pos.account.passwords-not-match') });
      } else if (this.newPassword) {
        adapi.post('users/reset-password', { code: this.activationCode, new_password: this.newPassword })
          .then(message => {
            this.loading = false;
            this.newPassword = null;
            this.$toast.info({ message });
            this.$router.push({ name: 'login', query: { next: this.nextRoute } });
          })
          .catch(error => {
            this.loading = false;
            this.$toast.error({ message: error.toString() });
          });
      } else {
        this.$toast.error({ message: this.$t('pos.login.please-enter-your-new-password') });
      }
    },
  },
};




// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/password-recovery/PasswordRecovery.js